/* sb-tpl-picker.js — the "what are you making?" product picker.
   2026-09-05.

   Two entry points use it:
     - the top bar link this file inserts next to Help Center (every page);
     - the "See All Design Templates" button inside the design center, which
       calls window.__sbTplPicker.show() (see sb-dc-tplbutton.js).

   The gallery holds 700-odd designs across a dozen products. Sending someone
   there cold means scrolling past retractables to find a sticker, so the link
   asks what they are making first and opens the gallery already filtered:
   /pages/design-templates?for=<product>, matched against the gallery's own
   product filter by sb-dc-tplfor.js.

   Always a new tab. On the storefront nobody should lose the product page they
   were reading; in the editor nobody should lose the design in progress, which
   is kept nowhere.

   Styling takes the theme's own variables rather than a palette of its own —
   --font-body-family (Roboto here), --color-button for the navy, --color-
   background for the tint. A restyle of the store carries into this dialog
   instead of leaving it looking like someone else's popup.

   The top bar link: cloned from the Help Center link so it inherits the inner
   <span class="body-small"> that sets the bar's 14.8px — built by hand it came
   out a size larger than its neighbours. It is then coloured amber and bolded,
   which is how it stands out now: same size as the rest of the bar, different
   colour, rather than simply bigger and whiter. */
(function () {
  'use strict';

  var LINK_CLASS = 'sb-tplpick-link';
  var MODAL_ID = 'sb-tplpick-modal';
  var BASE = '/pages/design-templates';
  var LABEL = 'Design Templates';
  var ACCENT = '#ffc533';   // amber against the bar's navy

  /* label  — what the customer reads
     filter — what the gallery's product filter calls it, when the two differ.
              sb-dc-tplfor.js matches the filter's own wording exactly first,
              so this must stay spelled as the gallery spells it.
     note   — one line under the name.

     Ordered the way a customer thinks: banners, backdrops, stands, stickers.
     2026-09-05: Mesh Banners, Window Decals / Adhesive and Kiss-Cut Stickers
     removed at the store's request; "Pop-Up Retractable Banner" shortened to
     "Retractable Banner". Everything removed is still reachable through
     "Browse all templates". */
  var ITEMS = [
    { label: 'Custom Vinyl Banners', note: 'Outdoor, indoor, any size' },
    { label: 'Fabric Banners', note: 'Soft, no glare' },
    { label: 'Step & Repeat Backdrops', note: 'Logo wall for photos' },
    { label: 'Pop-Up Display Backdrop', note: 'Fabric over a frame' },
    { label: 'Retractable Banner', filter: 'Pop-Up Retractable Banner', note: 'Roll-up stand' },
    { label: 'X-Banner / Double-Sided X-Banner', note: 'Light, portable stand' },
    { label: 'Round Stickers', note: 'Die-cut circles' },
    { label: 'Oval Stickers', note: 'Die-cut ovals' },
    { label: 'Bumper Stickers', note: 'Long rectangles' }
  ];

  function css() {
    if (document.getElementById('sb-tplpick-css')) return;
    var st = document.createElement('style');
    st.id = 'sb-tplpick-css';
    /* rgb(var(--color-button)) is the theme's navy; the fallbacks keep the
       dialog readable if a page ever loads without the theme's variables — the
       design center layout is one of those.
       The !important on the link colour is not laziness: the bar's own rule
       paints every link in that list 80% white, and it wins on specificity. */
    st.textContent =
      '.' + LINK_CLASS + ',.' + LINK_CLASS + ' span{color:' + ACCENT + ' !important;font-weight:700 !important}' +
      '.' + LINK_CLASS + ':hover,.' + LINK_CLASS + ':hover span{color:#ffd873 !important}' +
      '#' + MODAL_ID + '{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;' +
      'justify-content:center;padding:20px;background:rgba(7,39,71,.55);' +
      'font-family:var(--font-body-family,Roboto,Archivo,sans-serif)}' +
      '#' + MODAL_ID + ' .sb-tp-box{background:#fff;border-radius:6px;width:min(720px,96vw);' +
      'max-height:88vh;overflow:auto;padding:26px 26px 20px;box-shadow:0 18px 50px rgba(7,39,71,.28)}' +
      '#' + MODAL_ID + ' h2{margin:0 0 6px;font-family:inherit;font-size:22px;line-height:1.25;' +
      'font-weight:700;color:rgb(var(--color-button,7 39 71));text-transform:none;letter-spacing:0}' +
      '#' + MODAL_ID + ' p.sb-tp-sub{margin:0 0 18px;color:#5b6672;font-size:14px;line-height:1.5}' +
      '#' + MODAL_ID + ' .sb-tp-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:12px}' +
      '#' + MODAL_ID + ' button.sb-tp-item{text-align:left;border:1px solid #d5dde5;border-radius:6px;' +
      'background:#fff;padding:14px 15px;cursor:pointer;font-family:inherit;color:rgb(var(--color-button,7 39 71));' +
      'transition:border-color .15s ease,background-color .15s ease}' +
      '#' + MODAL_ID + ' button.sb-tp-item:hover{border-color:rgb(var(--color-button,7 39 71));' +
      'background:rgb(var(--color-background,238 242 247))}' +
      '#' + MODAL_ID + ' .sb-tp-item b{display:block;font-size:15px;line-height:1.35;font-weight:700}' +
      '#' + MODAL_ID + ' .sb-tp-item small{display:block;color:#6b7885;font-size:12.5px;margin-top:3px;font-weight:400}' +
      '#' + MODAL_ID + ' .sb-tp-foot{display:flex;justify-content:space-between;align-items:center;' +
      'margin-top:20px;gap:12px;flex-wrap:wrap}' +
      '#' + MODAL_ID + ' .sb-tp-all{background:none;border:0;font-family:inherit;font-size:14px;font-weight:700;' +
      'color:rgb(var(--color-button,7 39 71));text-decoration:underline;text-underline-offset:3px;' +
      'cursor:pointer;padding:6px 0}' +
      '#' + MODAL_ID + ' .sb-tp-close{border:0;background:rgb(var(--color-button,7 39 71));color:#fff;' +
      'border-radius:999px;padding:11px 26px;font-family:inherit;font-size:14px;font-weight:700;cursor:pointer}' +
      '#' + MODAL_ID + ' .sb-tp-close:hover{opacity:.9}';
    document.head.appendChild(st);
  }

  function open(url) { window.open(url, '_blank', 'noopener'); }

  function close() {
    var m = document.getElementById(MODAL_ID);
    if (m) m.remove();
    document.removeEventListener('keydown', onKey);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  function show() {
    if (document.getElementById(MODAL_ID)) return;
    css();
    var back = document.createElement('div');
    back.id = MODAL_ID;
    back.setAttribute('role', 'dialog');
    back.setAttribute('aria-modal', 'true');
    back.setAttribute('aria-label', 'Choose a product');

    var box = document.createElement('div');
    box.className = 'sb-tp-box';
    box.innerHTML =
      '<h2>What are you making?</h2>' +
      '<p class="sb-tp-sub">Pick a product and we will show the designs made for it. ' +
      'It opens in a new tab.</p><div class="sb-tp-grid"></div>' +
      '<div class="sb-tp-foot"><button type="button" class="sb-tp-all">Browse all templates \u203a</button>' +
      '<button type="button" class="sb-tp-close">Cancel</button></div>';

    var grid = box.querySelector('.sb-tp-grid');
    ITEMS.forEach(function (it) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sb-tp-item';
      b.innerHTML = '<b></b><small></small>';
      b.querySelector('b').textContent = it.label;
      b.querySelector('small').textContent = it.note;
      b.addEventListener('click', function () {
        open(BASE + '?for=' + encodeURIComponent(it.filter || it.label));
        close();
      });
      grid.appendChild(b);
    });

    box.querySelector('.sb-tp-all').addEventListener('click', function () { open(BASE); close(); });
    box.querySelector('.sb-tp-close').addEventListener('click', close);
    back.addEventListener('click', function (e) { if (e.target === back) close(); });
    document.addEventListener('keydown', onKey);

    back.appendChild(box);
    document.body.appendChild(back);
    var first = box.querySelector('button.sb-tp-item');
    if (first) first.focus();
  }

  /* Every list that carries Help Center (desktop bar, mobile drawer). Falls
     back to Bulk Order in case that label is the one that survives an edit.
     The design center has neither — nothing is inserted there, and the file is
     loaded only for show(). */
  function anchors() {
    var all = document.querySelectorAll('a'), help = [], bulk = [];
    for (var i = 0; i < all.length; i++) {
      var t = (all[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (/^help center$/i.test(t)) help.push(all[i]);
      else if (/^bulk order$/i.test(t)) bulk.push(all[i]);
    }
    return help.length ? help : bulk;
  }

  /* Copy the neighbour whole — anchor, inner span, classes and all — then swap
     the words, so the size and hover behaviour are the bar's own. Colour comes
     from the stylesheet above. */
  function makeLink(ref) {
    var a = ref.cloneNode(true);
    a.setAttribute('href', BASE);
    a.setAttribute('aria-label', LABEL);
    a.classList.add(LINK_CLASS);
    a.removeAttribute('id');
    var span = a.querySelector('span') || a;
    span.textContent = LABEL;
    if (span.hasAttribute && span.hasAttribute('title')) span.setAttribute('title', LABEL);
    a.addEventListener('click', function (e) { e.preventDefault(); show(); });
    return a;
  }

  function place() {
    css();
    anchors().forEach(function (ref) {
      var host = ref.parentNode;
      if (!host) return;
      /* Clone the whole list item when there is one, so spacing and separators
         come along instead of being guessed at. */
      var isLi = host.tagName === 'LI';
      var scope = isLi ? host.parentNode : host;
      if (!scope || scope.querySelector('.' + LINK_CLASS)) return;

      var link = makeLink(ref);
      if (isLi) {
        var li = host.cloneNode(false);
        li.appendChild(link);
        host.parentNode.insertBefore(li, host.nextSibling);
      } else {
        host.insertBefore(link, ref.nextSibling);
      }
    });
  }

  /* The editor's own button opens the same dialog through this. */
  window.__sbTplPicker = { show: show, close: close, items: ITEMS };

  function start() {
    place();
    /* Drawers and sticky headers re-render their markup, so keep an eye on it
       rather than running once. */
    var t = setInterval(place, 700);
    window.addEventListener('pagehide', function () { clearInterval(t); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
